import { cs } from "date-fns/locale";
import * as React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { Calendar } from "react-date-range";
import FlexBox, { CustomWidthE } from "../../../../components/FlexBox";
import Paragraph from "../../../../components/Paragraph";
import { isSafari } from "../../../../helpers/browsersCheck";
import { getDateTime, getStringDate } from "../../../../helpers/date";
import { CalendarWrapper } from "../../../../ui/CalendarWrapper";
import { MediaGroupsHelperContext } from "../../context-providers/MediaGroupsHelperContextProvider";
import { useMutateMedia } from "../../hooks/useMutateMedia";
import InsightItemWrapper from "../../ui/InsightItemWrapper";

type InputDateT = {
  id: number;
  label: string;
  participantId: string;
  date: string | null;
  permanentDisabled?: boolean;
  liveAddedMedia?: boolean;
};

const InputDate: React.FC<InputDateT> = ({
  id,
  label,
  participantId,
  date,
  permanentDisabled = false,
  liveAddedMedia,
}) => {
  const [dateState, setDateState] = useState<string | null>(date);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [openPopover, setOpenPopover] = useState<"open" | "close">("close");

  const { setDateCalendar } = useContext(MediaGroupsHelperContext);
  const calendarPositionWrapper = useRef<HTMLDivElement>(null);

  const { disabled, mutateMedia } = useMutateMedia(
    id,
    "published_at",
    participantId,
    undefined,
    liveAddedMedia ? "addedMediaGroups" : "mediaGroups"
  );

  const openDatePickerByWrapper = (): void => {
    if (!permanentDisabled) {
      setOpenPopover("open");
    }
  };

  useEffect(() => {
    setDateCalendar(
      openPopover === "open" && calendarPositionWrapper.current
        ? {
            calendar: (
              <CalendarWrapper customWidth={CustomWidthE.full}>
                <Calendar
                  locale={cs}
                  date={
                    dateState && !isSafari() ? new Date(dateState) : new Date()
                  }
                  onChange={(e: Date) => setDateState(getStringDate(e))}
                />
              </CalendarWrapper>
            ),
            xCor:
              calendarPositionWrapper.current.getBoundingClientRect().x +
              window.scrollX,
            yCor:
              calendarPositionWrapper.current.getBoundingClientRect().y +
              window.scrollY,
            closeCalendar: () => setOpenPopover("close"),
          }
        : undefined
    );
  }, [openPopover]);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);

      return;
    }

    if (openPopover === "open" && !disabled) {
      mutateMedia(dateState);
      setOpenPopover("close");
    }
  }, [dateState]);

  return (
    <InsightItemWrapper
      onClick={openDatePickerByWrapper}
      label={label}
      disabled={permanentDisabled}
    >
      <FlexBox
        position="relative"
        zIndex={openPopover === "open" ? 3 : "auto"}
        customWidth={CustomWidthE.full}
        justifyContent="flex-start"
        ref={calendarPositionWrapper}
      >
        <Paragraph
          paragraph={date ? getDateTime(date, "shortDate") : "-"}
          fontWeight={permanentDisabled ? 500 : 600}
        />
      </FlexBox>
    </InsightItemWrapper>
  );
};

export default InputDate;
